export const types = {
    SET_CUSTOMER_EQUIPMENTS: "SET_CUSTOMER_EQUIPMENTS",
    SET_CUSTOMER_EQUIPMENTS_LOADING: "SET_LOADING",
    SET_REFRESH_CUSTOMER_EQUIPMENTS_STATUS: "SET_REFRESH_CUSTOMER_EQUIPMENTS_STATUS"
};
